export type PrimitiveType = boolean | number | string | undefined | symbol;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPrimitive = (value: any): value is PrimitiveType => {
    const primitiveTypes = ['string', 'number', 'boolean', 'undefined', 'symbol'];

    return primitiveTypes.some((type) => typeof value === type);
};
